import React from 'react'
import { BaseProvider } from '@!/providers'
import { PaymentError } from '@!/ExternalPayment/CoinPurchase/containers/PaymentError'

export default function PaymentErrorApp({ error_type }) {
  return (
    <BaseProvider>
      <PaymentError errorType={error_type} />
    </BaseProvider>
  )
}
